import styled from 'styled-components';

export const Container = styled.div`
  width: 82%;
  padding: 20px;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  background-color: white;
  margin-top: 10px;
  margin-right: auto;
  margin-left: auto;
  margin-bottom: 100px;
  border-radius: 4px;
`;

export const LinkButton = styled.a`
  text-decoration: none;
  color: ${process.env.REACT_APP_COLOR_RC_ACTIONS};
  font-weight: bold;
  display: block;
  text-align: center;
  padding: 21px 0;
  font-size: 15px;
`;

export const BodyText = styled.div`
p {
  margin-bottom: 25px;
}
b, strong, h1, h2, h3, h4, h5, h6 {
  font-weight: bold;
}
h1 { font-size: 22px; }
h2 { font-size: 20px; }
h3 { font-size: 18px; }
h4 { font-size: 16px; }
h5 { font-size: 14px; }
h6 { font-size: 13px; }
`;
